export const fontsRoboto = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-Thin.ttf`,
      },
    ],
    weight: "100",
  },
  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-ThinItalic.ttf`,
      },
    ],
    weight: "100",
  },
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-Light.ttf`,
      },
    ],
    weight: "300",
  },
  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-LightItalic.ttf`,
      },
    ],
    weight: "300",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-Regular.ttf`,
      },
    ],
    weight: "400",
  },

  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-RegularItalic.ttf`,
      },
    ],
    weight: "400",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-Medium.ttf`,
      },
    ],
    weight: "500",
  },

  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-MediumItalic.ttf`,
      },
    ],
    weight: "500",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-Bold.ttf`,
      },
    ],
    weight: "700",
  },

  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-BoldItalic.ttf`,
      },
    ],
    weight: "700",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-Black.ttf`,
      },
    ],
    weight: "900",
  },

  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: `/fonts/Roboto-BlackItalic.ttf`,
      },
    ],
    weight: "900",
  },
];
